import { createSlice } from '@reduxjs/toolkit';
import { IRELAND_COORDINATES } from 'helpers/constant';

export const landDevSlice = createSlice({
  name: 'landDev',
  initialState: {
    currentState: 1,
    list: [],
    steps: [
      {
        icon: 'map',
        label: 'Select Parcels'
      },
      {
        icon: 'edit',
        label: 'Develop Land'
      },
      {
        icon: 'table',
        label: 'Summary Report'
      },
      {
        icon: 'thumbs-up',
        label: 'Project Description'
      }
    ],
    selectedRowsData: [],
    centerCoor: IRELAND_COORDINATES,
    workspace: process.env.REACT_APP_GEOSERVER_WORKSPACE,
    layerName: process.env.REACT_APP_GEOSERVER_LAYER_NAME,
    plantingDataSource: [],
    allMarkerPoints: [],
    selectedLandParcels: [],
    location: null,
    zoom: 8,
    landParcels: [],
    itemType: 1
  },
  reducers: {
    nextState: state => {
      if (state.currentState < 10) {
        state.currentState += 1;
      }
    },
    prevState: state => {
      if (state.currentState > 1) {
        state.currentState -= 1;
      }

      if (state.currentState == 1) {
        state.allMarkerPoints = [];
        state.plantingDataSource = [];
      }
    },
    setDataList: (state, action) => {
      state.list = action.payload;
    },
    setSelectedRowData: (state, action) => {
      const newData = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      state.selectedRowsData = [...state.selectedRowsData, ...newData];
    },
    setAllMarkerPoints: (state, action) => {
      state.allMarkerPoints = [...state.allMarkerPoints, action.payload];
    },
    addDrawnLandParcel: (state, action) => {
      const parcel = action.payload;
      state.landParcels = [parcel, ...state.landParcels];
      state.selectedLandParcels = [parcel, ...state.selectedLandParcels];
    },
    toggleSelectLandParcel: (state, action) => {
      const parcel = action.payload;
      if (state.selectedLandParcels.find(p => p.id === parcel.id)) {
        state.selectedLandParcels = state.selectedLandParcels.filter(
          p => p.id !== parcel.id
        );
      } else {
        state.selectedLandParcels = [parcel, ...state.selectedLandParcels];
      }
      if (state.allMarkerPoints.find(m => m.parcel === parcel.parcelId)) {
        state.allMarkerPoints = state.allMarkerPoints.filter(
          m => m.parcel !== parcel.parcelId
        );
      }
      if (state.plantingDataSource.find(p => p.parcel === parcel.parcelId)) {
        state.plantingDataSource = state.plantingDataSource.filter(
          p => p.parcel !== parcel.parcelId
        );
      }
    },
    setLocation: (state, action) => {
      state.location = action.payload;
    },
    setZoom: (state, action) => {
      state.zoom = action.payload;
    },
    removeDrawnLandParcel: (state, action) => {
      const parcel = action.payload;
      state.selectedLandParcels = state.selectedLandParcels.filter(
        p => p.id !== parcel.id
      );
      state.landParcels = state.landParcels.filter(p => p.id !== parcel.id);
      if (state.allMarkerPoints.find(m => m.parcel === parcel.parcelId)) {
        state.allMarkerPoints = state.allMarkerPoints.filter(
          m => m.parcel !== parcel.parcelId
        );
      }
      if (state.plantingDataSource.find(p => p.parcel === parcel.parcelId)) {
        state.plantingDataSource = state.plantingDataSource.filter(
          p => p.parcel !== parcel.parcelId
        );
      }
    },
    removePlantedItems: (state, action) => {
      const item = action.payload;

      state.plantingDataSource = state.plantingDataSource.filter(
        p => p.id !== item
      );

      state.allMarkerPoints = state.allMarkerPoints.filter(m => {
        return state.plantingDataSource.some(
          p =>
            m.parcel === p.parcel &&
            m.itemType.toString() === p.itemType.toString()
        );
      });
    },
    setCenterCoor: (state, action) => {
      state.centerCoor = action.payload;
    },
    reset: state => ({
      ...state,
      currentState: 1,
      list: [],
      selectedRowsData: [],
      centerCoor: IRELAND_COORDINATES,
      plantingDataSource: [],
      allMarkerPoints: [],
      selectedLandParcels: [],
      location: null,
      landParcels: [],
      originalPolygon: [],
      zoom: 8
    }),
    setPlantingDataSource: (state, action) => {
      state.plantingDataSource = [...state.plantingDataSource, action.payload];
    },
    setItemType: (state, action) => {
      state.itemType = action.payload;
    }
  }
});

export const {
  nextState,
  prevState,
  setDataList,
  setSelectedRowData,
  setAllMarkerPoints,
  addDrawnLandParcel,
  toggleSelectLandParcel,
  setLocation,
  setZoom,
  removeDrawnLandParcel,
  reset,
  setCenterCoor,
  setPlantingDataSource,
  setItemType,
  removePlantedItems
} = landDevSlice.actions;

export default landDevSlice.reducer;
